module.exports = __webpack_public_path__ + "img/cattunnel36.42594dc9.jpg";